import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { getToken } from './api/client';

// Reverb speaks the Pusher protocol; Echo expects a Pusher-like client.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).Pusher = Pusher;

const REVERB_KEY = import.meta.env.VITE_REVERB_APP_KEY ?? '';
const REVERB_HOST = import.meta.env.VITE_REVERB_HOST ?? 'localhost';
const REVERB_PORT = Number(import.meta.env.VITE_REVERB_PORT ?? '8080');
const REVERB_SCHEME = (import.meta.env.VITE_REVERB_SCHEME ?? 'http').toLowerCase();

export const echo =
  REVERB_KEY && REVERB_HOST
    ? new Echo({
        broadcaster: 'reverb',
        key: REVERB_KEY,
        wsHost: REVERB_HOST,
        wsPort: REVERB_PORT,
        wssPort: REVERB_PORT,
        forceTLS: REVERB_SCHEME === 'https',
        encrypted: REVERB_SCHEME === 'https',
        disableStats: true,
        enabledTransports: ['ws'],
        authEndpoint: `${(import.meta.env.VITE_API_URL ?? '').replace(/\/$/, '')}/broadcasting/auth`,
        auth: {
          headers: {
            Authorization: (() => {
              const token = getToken();
              return token ? `Bearer ${token}` : '';
            })(),
          },
        },
      })
    : null;

